// @ts-nocheck
// Config starter code
// @ts-ignore
import React from 'react';
import { createChatBotMessage } from 'react-chatbot-kit';
import Email from '../Email';
import SocialShare from '../SocialShare';

import BotAvatar from './layaout/BotAvatar';
import ChatHeader from './layaout/ChatHeader';
import Options from './widgets/Options';

const botName = 'JuanquiBot';
const config = {
  botName: 'JuanquiBot',
  initialMessages: [
    createChatBotMessage(
      `Hola soy ${botName}, ahora Juanqui debe estar programando, pero podes hablar conmigo, soy tan simpatico como él. En que puedo ayudarte?`,
      {
        delay: 500,
        widget: 'options',
      }
    ),
  ],
  customComponents: {
    header: () => <ChatHeader />,
    botAvatar: () => <BotAvatar />,
  },

  customStyles: {
    // Overrides the chatbot message styles
    botMessageBox: {
      backgroundColor: '#376B7E',
      'font-size': '1rem',
    },
    // Overrides the chat button styles
    chatButton: {
      backgroundColor: '#5ccc9d',
    },
  },

  widgets: [
    {
      widgetName: 'options',
      widgetFunc: props => <Options {...props} />,
    },

    {
      widgetName: 'share',
      widgetFunc: props => <SocialShare {...props} />,
    },

    {
      widgetName: 'email',
      widgetFunc: props => <Email {...props} />,
      props: {
        email: 'juan.cantero@outlook.com',
      },
    },
  ],
};

export default config;
